import React from 'react';
import './Styles/Hangman.css';

export class Hangman extends React.Component {
  render() {
    return (
      <div className="Hangman">{this.getParts().map(this.partToHTML)}</div>
    );
  }

  partToHTML = part => {
    let classes = 'Hangman__Part ';
    if (part.found) {
      classes += 'Hangman__Part--Found ';
    }
    let content = part.found ? part.value : part.value.length;

    return (
      <div key={part.value + part.index} className={classes}>
        {content}
      </div>
    );
  };

  getParts = () => {
    const { secret, correctGuesses, displayEnds } = this.props;

    let parts = [];
    const secArr = secret.split('');

    for (let i = 0; i < secret.length; i++) {
      const letter = secArr[i];

      if (
        (i === 0 && displayEnds) ||
        (i === secret.length - 1 && displayEnds) ||
        correctGuesses.includes(letter)
      ) {
        if (parts.length === 0 || !parts[parts.length - 1].found) {
          parts.push({ value: letter, found: true, index: i });
        } else {
          let part = parts.pop();
          part.value += letter;
          parts.push(part);
        }
      } else if (parts.length === 0 || parts[parts.length - 1].found) {
        parts.push({ value: letter, found: false, index: i });
      } else {
        let part = parts.pop();
        part.value += letter;
        parts.push(part);
      }
    }
    return parts;
  };
}
